import type { ProgramEventSlim } from 'models';
import { DataCard } from 'ui';
import { images } from 'common/utils';
import { useEventRsvpLabels } from '../../hooks';
import { useGetEventTagsProperties } from '../../hooks/useGetEventTagsProperties';

type P = {
  event: ProgramEventSlim;
  getPathToEventDetail: (id: string) => string;
  showTag?: boolean;
};

const EventCard = ({
  event: { coverPhoto, endTime, eventType, goingInviteesCount, id, name, nodeId, startTime },
  getPathToEventDetail,
  showTag = true,
}: P) => {
  // TODO: this card is used in the channels and only published events are displayed there
  const tags = useGetEventTagsProperties({ endTime, eventType, startTime, status: 'published' });
  const { getInviteesAcceptedLabel } = useEventRsvpLabels();

  return (
    <DataCard
      className="event-card"
      description={{
        dateFrom: startTime,
        dateTo: endTime,
      }}
      image={{
        alt: 'Event cover image',
        src: coverPhoto?.url ?? images.default.eventCoverPhoto,
      }}
      participantsProperties={{
        count: goingInviteesCount,
        label: (formattedCount) => getInviteesAcceptedLabel({ formattedInvitees: formattedCount }),
      }}
      path={getPathToEventDetail(nodeId ?? id)}
      tag={showTag ? tags : undefined}
      title={name}
    />
  );
};

export default EventCard;
